import 'leaflet.path.drag';

export function disableDragging(featureGroupRef: React.MutableRefObject<null>) {
    //@ts-ignore
    if (featureGroupRef && featureGroupRef.current && featureGroupRef.current._layers) {
        //@ts-ignore
        let layers = Object.values(featureGroupRef.current._layers);

        layers.map((layer: any) => layer.dragging.disable());
    }
}
